import React from "react";
import Favicon from "react-favicon";
import { useGetRegDetails } from "./dataloader";
import { RegDetailProviderArgType } from "./type";
import { getRegistrationKey } from "../../utils/config";
import { ApiRegistration } from "shared/types/ApiRegistration";
import { setLocaleId, setRegKey } from "shared/utils";

const RegDetailContext = React.createContext<ApiRegistration>({} as ApiRegistration);

function RegDetailProvider(props: RegDetailProviderArgType) {
  const updateRegistrationDetailsInStorage = React.useCallback((details: ApiRegistration) => {
    setLocaleId(details.localeId);
    setRegKey(getRegistrationKey());
  }, []);

  const { data } = useGetRegDetails({
    regKey: getRegistrationKey(),
    successHandler: updateRegistrationDetailsInStorage
  });

  if (!data?.id) {
    return null;
  }

  return (
    <React.Fragment>
      <Favicon url={data?.favicon} />
      <RegDetailContext.Provider value={data} {...props} />
    </React.Fragment>
  );
}

function useRegDetail() {
  const context = React.useContext(RegDetailContext);
  if (context === undefined) {
    throw new Error(`useRegDetail must be used within a RegDetailProvider`);
  }
  return context;
}

export { useRegDetail, RegDetailProvider };
